import { createFileRoute } from '@tanstack/react-router'
import { realEstateTabGuard, TASK_READ } from '~/components/routes/development/real-estate/tabs'
import { RealEstateTasksTab } from '~/components/routes/development/real-estate/tasks/tasks-tab'

export const Route = createFileRoute('/_authenticated/development/real-estate/tasks')({
  staticData: { permission: TASK_READ },
  beforeLoad: realEstateTabGuard('tasks'),
  component: RealEstateTasksTab,
})
